import { Component, Input } from '@angular/core';

import { EventModel, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { Nullable, NumberDictionary } from '@frontend/sports/common/core/utils/extended-types';

import { UrlHelperService } from '../navigation-core/url-helper.service';
import { OutrightTileData } from './marquee-tile.model';
import { MarqueeTrackingService } from './marquee-tracking.service';

@Component({
    selector: 'ms-outrights-marquee-card',
    templateUrl: 'outrights-marquee-card.html',
})
export class OutrightsMarqueeCardComponent {
    @Input() tile: OutrightTileData;
    @Input() textColor: string;
    @Input() outrightOptionGroup: NumberDictionary<EventOptionGroup>;
    @Input() event: EventModel;
    @Input() backgroundImage: string;
    @Input() globalLink: string;
    shouldRemoveHref: Nullable<boolean>;

    constructor(
        private marqueeTrackingService: MarqueeTrackingService,
        private urlHelper: UrlHelperService,
    ) {
        this.shouldRemoveHref = this.urlHelper.shouldRemoveHref();
    }

    trackOutrightClicks(index: number, globalLink: string, sportId: number, competitionId: number, backgroundImage: string): void {
        this.marqueeTrackingService.trackOutrightClicks(index, globalLink, sportId, competitionId, backgroundImage);
    }
}
